import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-arrow-navigation/jb-arrow-navigation.scss?inline
var jb_arrow_navigation_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

.arrow-navigation {
  display: flex;
  gap: var(--spacing-s);
  justify-content: flex-end;
}`;

// src/components/jb-arrow-navigation/jb-arrow-navigation.ts
var JbArrowNavigation = class extends h {
  clickNext() {
    this.dispatchEvent(
      new CustomEvent(`jb-arrow-navigation:next-clicked`, {
        bubbles: true,
        composed: true
      })
    );
  }
  clickPrev() {
    this.dispatchEvent(
      new CustomEvent(`jb-arrow-navigation:prev-clicked`, {
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`
      <div class="arrow-navigation">
        <jb-arrow-icon
          direction="left"
          .disabled=${this.prevDisabled}
          @click=${this.clickPrev}
        ></jb-arrow-icon>
        <jb-arrow-icon
          direction="right"
          @click=${this.clickNext}
          .disabled=${this.nextDisabled}
        ></jb-arrow-icon>
      </div>
    `;
  }
};
JbArrowNavigation.styles = r(jb_arrow_navigation_default);
__decorateClass([
  n({ type: Boolean })
], JbArrowNavigation.prototype, "nextDisabled", 2);
__decorateClass([
  n({ type: Boolean })
], JbArrowNavigation.prototype, "prevDisabled", 2);
JbArrowNavigation = __decorateClass([
  customElement("jb-arrow-navigation")
], JbArrowNavigation);

export {
  JbArrowNavigation
};
